module.exports = __webpack_public_path__ + "img/zgsf_jxk.f640d5b9.svg";